module.exports = __webpack_public_path__ + "img/logo.0629d9bf.png";